<div class="sources-tab-content">
  <div class="tab-header">
    <h4>Data Sources</h4>
    <p>Sources linked to the selected master record</p>
  </div>

  <div class="tab-body">
    <div *ngIf="noRecordSelected" class="placeholder-content">
      <i class="material-icons">storage</i>
      <h5>Select a master record</h5>
      <p>Select a row from the master grid to view its data sources.</p>
    </div>

    <div *ngIf="!noRecordSelected && loading" class="placeholder-content">
      <i class="material-icons">hourglass_empty</i>
      <h5>Loading sources…</h5>
    </div>

    <div *ngIf="!noRecordSelected && errorMessage" class="error-message">
      <i class="material-icons">error_outline</i>
      <p>{{ errorMessage }}</p>
    </div>

    <div *ngIf="!noRecordSelected && !loading && !errorMessage" class="grid-container">
      <td-grid
        *ngIf="gridOptions"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [defaultColDef]="gridOptions.defaultColDef"
        [rowSelection]="gridOptions.rowSelection"
        [rowMultiSelectWithClick]="gridOptions.rowMultiSelectWithClick"
        [suppressNoRowsOverlay]="gridOptions.suppressNoRowsOverlay"
        [pagination]="gridOptions.pagination"
        [paginationPageSize]="gridOptions.paginationPageSize"
        [paginationPageSizeSelector]="gridOptions.paginationPageSizeSelector"
        [localeText]="gridOptions.localeText"
        [rowData]="sourcesRowData"
        (gridReady)="onGridReady($event)"
      ></td-grid>
    </div>
  </div>
</div>
